import styled from 'styled-components';
import { Input } from 'antd';

export const InputStyled = styled(Input)`
  height: 40px;
  font-size: 14px;
  input {
    &::placeholder {
      font-size: 14px;
    }
  }
`;
